<template>
  <v-tooltip top color="#827717">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item :key="hApp.name" v-bind="attrs" v-on="on" @click="loadHAppProperties(hApp)">
        <v-list-item-icon>
          <v-icon medium>mdi-office-building-marker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="hApp.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <span v-text="hApp.name"></span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'hAppComponent',
  components: {

  },
  data () {
    return {

    }
  },
  props: {
    hApp: {
      required: true,
      type: Object,
      default: {
        name: ""
      }
    }
  },
  methods: {
    loadHAppProperties (hApp) {
      EventBus.$emit('LoadHAppComponent', hApp)
    }
  }
}
</script>

<style scoped>
.v-icon {
  color: #f9fbe7;
}

.v-list-item__title {
  color: #f9fbe7;
}

.v-list-item:hover {
  background-color: #9e9d24;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HApp/HApp.vue